import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';

function SpotifyCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        if (code && state) {
          await authService.handleCallback(code, state);
          navigate('/');
        } else {
          console.error('Code or state missing from callback');
          navigate('/');
        }
      } catch (error) {
        console.error('Error during callback:', error);
        navigate('/');
      }
    };

    handleCallback();
  }, [navigate, location]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p>Connexion en cours...</p>
    </div>
  );
}

export default SpotifyCallback;